import { createContext } from "react";

export const ExperimentTrackingString = createContext<string>("");
